import './style.scss'

const Loading = () => {
  return (
    <div className='loading-container'>
      <div className='loading-spinner--1'></div>
      <div className='loading-spinner--2'></div>
    </div>
  )
}

export default Loading
